export default "__VITE_ASSET__CGAPOXmp__"